import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HierarchyDropdownComponent } from './hierarchy-dropdown.component';
import { MatMenuModule } from '@angular/material/menu';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { HierarchyDropdownSubMenuComponent } from 'shared/components/hierarchy-dropdown/hierarchy-dropdown-sub-menu/hierarchy-dropdown-sub-menu.component';

@NgModule({
  imports: [
    CommonModule,
    MatMenuModule,
    SvgIconModule
  ],
  declarations: [
    HierarchyDropdownComponent,
    HierarchyDropdownSubMenuComponent
  ],
  exports: [
    HierarchyDropdownComponent,
    HierarchyDropdownSubMenuComponent
  ]
})

export class HierarchyDropdownModule {}
